const { videojs } = window
export const Component = videojs.getComponent('Component')
export const PLUGIN_NAME = 'VolumeBar'
export const COMPONENT_NAME = 'VolumeBarComponent'

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you if not, remove the wait for "ready"!
 *
 * @function VolumeBarButton
 * @param    {Object} [options={}]
 * An object of options left to the plugin author to define.
 */
function VolumeBarButton (options = {}) {
  this.ready(function onPlayerReady () {
    const player = this
    player.controlBar.VolumeBarComponent = player.controlBar.addChild(
      COMPONENT_NAME,
      {
        staticText: options.staticText,
      },
    )
  })
}

/**
 * Control bar class (vertical volume bar set up)
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends ControlBar
 * @class VolumeBarVertical
 */
class VolumeBarVertical extends Component {
  constructor (player, options) {
    super(player, options)
    this.setLocalizeText(options, player)
    this.setVolumeBarVertical(player)
  }

  // eslint-disable-next-line class-methods-use-this
  getMuteStaticText (options) {
    const { staticText } = options
    return staticText.get('mute', 'Mute')
  }

  // eslint-disable-next-line class-methods-use-this
  getMuteToggle (player) {
    return player.controlBar.getChild('VolumePanel').getChild('MuteToggle')
  }

  setLocalizeText (options, player) {
    const volumeButton = this.getMuteToggle(player)
    volumeButton.controlText(
      volumeButton.localize(this.getMuteStaticText(options)),
    )
  }

  // eslint-disable-next-line class-methods-use-this
  setVolumeBarVertical (player) {
    const ctrlBar = player.getChild('ControlBar')
    const volPanel = ctrlBar.getChild('VolumePanel')
    const volCtrl = volPanel.getChild('VolumeControl')
    const volBar = volCtrl.getChild('VolumeBar')

    volPanel.options({ inline: false })
    volPanel.removeClass('vjs-volume-panel-horizontal')
    volPanel.addClass('vjs-volume-panel-vertical')
    volCtrl.options({ vertical: true })
    volCtrl.removeClass('vjs-volume-horizontal')
    volCtrl.addClass('vjs-volume-vertical')
    volBar.vertical(true)
    volBar.removeClass('vjs-slider-horizontal')
  }
}

// eslint-disable-next-line no-shadow
export function register (videojs = window.videojs) {
  videojs.registerComponent(COMPONENT_NAME, VolumeBarVertical)

  // Register the plugin with video.js.
  registerPlugin(PLUGIN_NAME, VolumeBarButton)
}
